import { getToken } from "../utils/auth";
import { obtenerVerificacionToken } from "../helpers/verificarTokenRequest";
﻿import React, { createContext, useState, useEffect } from 'react';

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
    const [ordenesPago, setOrdenesPago] = useState([]);
    const [tokenValido, setTokenValido] = useState(false);

    const apiUrlListaOrdenesPago = process.env.REACT_APP_API_PDF_LISTA_OP;
    const apiUrlToken = process.env.REACT_APP_API_TOKEN;

    // Verificar si el token es válido
    const verificarToken = async () => {
        const token = getToken();
        if (!token) {
            setTokenValido(false);
            return;
        }

        try {
            const { ok, rol, error } = await obtenerVerificacionToken(apiUrlToken, token);

            if (!ok) {
                throw new Error('Token inválido');
            }

            if (error) {
                throw error;
            }

            setTokenValido(rol === 8); // Asegúrate de que este código sea el correcto para token válido
        } catch (error) {
            console.error('Error al verificar el token:', error);
            setTokenValido(false);
        }
    };

    // Obtener lista de órdenes de pago
    const fetchOrdenesPago = async (fecha = "") => {
        const token = getToken();
        if (!token) return;

        try {
            const response = await fetch(apiUrlListaOrdenesPago, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: token, Fecha: fecha }),
            });

            if (response.ok) {
                setOrdenesPago(await response.json());
            } else {
                console.error('Error al obtener las órdenes de pago', response.status);
            }
        } catch (error) {
            console.error('Error en la solicitud de órdenes de pago:', error);
        }
    };

    // Efecto para verificar el token al cargar
    useEffect(() => {
        verificarToken();
    }, []);

    // Efecto para obtener la lista si el token es válido
    useEffect(() => {
        if (tokenValido) {
            fetchOrdenesPago(); // Inicialmente sin fecha
        }
    }, [tokenValido]);

    return (
        <AdminContext.Provider
            value={{
                tokenValido,
                ordenesPago,
                fetchOrdenesPago,
            }}
        >
            {children}
        </AdminContext.Provider>
    );
};
